<template>
	<div id="smtestingfield-main">
		<div class="row mb-1" v-if="!isModal">
			<div class="col-sm-7">
				<div class="d-flex align-items-center mb-2">
					<a id="add_smtestingfield_btn" class="btn btn-dark btn-sm me-4 d-flex align-items-center gap-2" :href="docRoot+'/smtestingfield'" role="button"><i class="ph ph-arrow-left "></i>Back to list</a>
					<h4 class="m-0 text-capitalize">Add SM testing field</h4>
				</div>
			</div>
		</div>
		<div class='row mb-4 gy-3 gy-md-0'>
			<div class="col-md-4">
				<label for="add_cscinspectiontank_company_id" class="form-label text-uppercase fw-bold me-3">Company Name</label>
				<div>
					<multiselect v-model="smtestingfieldFormObj.company_id" :options="allCompanyIdList" :custom-label="displayLabelSetting"  placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
				</div>
			</div>
			<div class="col-md-4">
				<label for="add_cscinspectiontank_inspection_date" class="form-label text-uppercase fw-bold me-3">Inspection Date</label>
				<div class="input-group">
					<MaskInput v-model="smtestingfieldFormObj.inspection_date" mask="##-##-####" class="form-control" textmode="uppercase" placeholder="DD-MM-YYYY"/>
				</div>
			</div>
			<div class="col-md-4">
				<label for="add_scope" class="form-label text-uppercase fw-bold me-3">Scope</label>
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.scope" id="add_scope" placeholder="Enter scope" >
				</div>
			</div>
		</div>
		<div class='row mb-4 gy-3 gy-md-0'>
			<div class="col-md-4">
				<label for="add_cscinspectiontank_inspection_location_id" class="form-label text-uppercase fw-bold me-3">Place of Inspection</label>
				<div>
					<multiselect v-model="smtestingfieldFormObj.inspection_location_id" :options="allInspectionLocationIdList" :custom-label="displayLabelSetting"  placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
				</div>
				
			</div>
			<div class="col-md-4">
				<label for="add_cscinspectiontank_operator_lessor" class="form-label text-uppercase fw-bold me-3">Operator/Lessor</label>
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.operator_lessor" id="add_cscinspectiontank_operator_lessor" placeholder="Enter Operator/Lessor" >
					
				</div>
				
			</div>
			<div class="col-md-4">
				<label for="add_cscinspectiontank_tank_no" class="form-label text-uppercase fw-bold me-3">Owner's Serial Number</label>
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_no" id="add_cscinspectiontank_tank_no" placeholder="Enter Tank No" >
					
				</div>
				
			</div>
		</div>
		<div class='row mb-4 gy-3 gy-md-0'>
			<div class="col-md-6">
				<label for="add_cscinspectiontank_mfg" class="form-label text-uppercase fw-bold me-3">Manufacturer</label>
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.mfg" id="add_cscinspectiontank_mfg" placeholder="Enter Mfg" >
					
				</div>
				
			</div>
			<div class="col-md-6">
				<label for="add_cscinspectiontank_mfg_sr_no" class="form-label text-uppercase fw-bold me-3">Manufacturer Sr No</label>
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.mfg_sr_no" id="add_cscinspectiontank_mfg_sr_no" placeholder="Enter Mfg Sr No" >
					
				</div>
				
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-12">
				<h4 class="m-0 fw-bold">Applicable Regulations. Enter initial approval No. as applicable</h4>
			</div>
		</div>
		<div class='row mb-4 gy-3 gy-md-0'>
			<div class="col-md-6">
				<label for="add_cscinspectiontank_csc" class="form-label text-uppercase fw-bold me-3">Csc</label>
				<div class="d-flex flex-row gap-2">
					<input type="text" class="form-control w-100"  v-model="smtestingfieldFormObj.csc" id="add_cscinspectiontank_csc" placeholder="Enter Csc" >
					<input type="text" class="form-control w-25"  v-model="smtestingfieldFormObj.csc_blank" id="add_cscinspectiontank_csc" >
				</div>
			</div>
			<div class="col-md-6">
				<label for="add_cscinspectiontank_uk_dot" class="form-label text-uppercase fw-bold me-3">Uk Dot</label>
				<div class="d-flex flex-row gap-2">
					<input type="text" class="form-control w-100"  v-model="smtestingfieldFormObj.uk_dot" id="add_cscinspectiontank_uk_dot" placeholder="Enter Uk Dot" >
					<input type="text" class="form-control w-25"  v-model="smtestingfieldFormObj.uk_dot_blank" id="add_cscinspectiontank_uk_dot_blank">
				</div>
			</div>
		</div>
		<div class='row mb-4 gy-3 gy-md-0'>
			<div class="col-md-6">
				<label for="add_cscinspectiontank_imdg" class="form-label text-uppercase fw-bold me-3">Imdg</label>
				<div class="d-flex flex-row gap-2">
					<input type="text" class="form-control w-100"  v-model="smtestingfieldFormObj.imdg" id="add_cscinspectiontank_imdg" placeholder="Enter Imdg" >
					<input type="text" class="form-control w-25"  v-model="smtestingfieldFormObj.imdg_blank" id="add_cscinspectiontank_imdg_blank">
				</div>
				
			</div>
			<div class="col-md-6">
				<label for="add_cscinspectiontank_us_dot" class="form-label text-uppercase fw-bold me-3">Us Dot</label>
				<div class="d-flex flex-row gap-2">
					<input type="text" class="form-control w-100"  v-model="smtestingfieldFormObj.us_dot" id="add_cscinspectiontank_us_dot" placeholder="Enter Us Dot" >
					<input type="text" class="form-control w-25"  v-model="smtestingfieldFormObj.us_dot_blank" id="add_cscinspectiontank_us_dot_blank">
				</div>
				
			</div>
		</div>
		<div class='row mb-4 gy-3 gy-md-0'>
			<div class="col-md-6">
				<label for="add_cscinspectiontank_rid" class="form-label text-uppercase fw-bold me-3">Rid</label>
				<div class="d-flex flex-row gap-2">
					<input type="text" class="form-control w-100"  v-model="smtestingfieldFormObj.rid" id="add_cscinspectiontank_rid" placeholder="Enter Rid" >
					<input type="text" class="form-control w-25"  v-model="smtestingfieldFormObj.rid_blank" id="add_cscinspectiontank_rid_blank" >
				</div>
			</div>
			<div class="col-md-6">
				<label for="add_cscinspectiontank_aar" class="form-label text-uppercase fw-bold me-3">Aar</label>
				<div class="d-flex flex-row gap-2">
					<input type="text" class="form-control w-100"  v-model="smtestingfieldFormObj.aar" id="add_cscinspectiontank_aar" placeholder="Enter Aar" >
					<input type="text" class="form-control w-25"  v-model="smtestingfieldFormObj.aar_blank" id="add_cscinspectiontank_aar_blank">
				</div>
				
			</div>
		</div>
		<div class='row mb-4 gy-3 gy-md-0'>
			<div class="col-md-6">
				<label for="add_cscinspectiontank_bam" class="form-label text-uppercase fw-bold me-3">Bam</label>
				<div class="d-flex flex-row gap-2">
					<input type="text" class="form-control w-100"  v-model="smtestingfieldFormObj.bam" id="add_cscinspectiontank_bam" placeholder="Enter Bam" >
					<input type="text" class="form-control w-25"  v-model="smtestingfieldFormObj.bam_blank" id="add_cscinspectiontank_bam_blank">
				</div>
			</div>
			<div class="col-md-6">
				<label for="add_cscinspectiontank_tc_impact" class="form-label text-uppercase fw-bold me-3">Tc Impact</label>
				<div class="d-flex flex-row gap-2">
					<input type="text" class="form-control w-100"  v-model="smtestingfieldFormObj.tc_impact" id="add_cscinspectiontank_tc_impact" placeholder="Enter Tc Impact" >
					<input type="text" class="form-control w-25"  v-model="smtestingfieldFormObj.tc_impact_blank" id="add_cscinspectiontank_tc_impact_blank">
				</div>
			</div>
		</div>
		<div class='row mb-4 gy-3 gy-md-0'>
			<div class="col-md-4">
				<label for="add_cscinspectiontank_tir" class="form-label text-uppercase fw-bold me-3">Tir</label>
				<div class="d-flex flex-row gap-2">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tir" id="add_cscinspectiontank_tir" placeholder="Enter Tir" >
					<input type="text" class="form-control w-50"  v-model="smtestingfieldFormObj.tir_blank" id="add_cscinspectiontank_tir_blank" >
				</div>
				
			</div>
			<div class="col-md-4">
				<label for="add_cscinspectiontank_uic" class="form-label text-uppercase fw-bold me-3">Uic</label>
				<div class="d-flex flex-row gap-2">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.uic" id="add_cscinspectiontank_uic" placeholder="Enter Uic" >
					<input type="text" class="form-control w-50"  v-model="smtestingfieldFormObj.uic_blank" id="add_cscinspectiontank_uic_blank" >
				</div>
			</div>
			<div class="col-md-4">
				<label for="add_cscinspectiontank_fra" class="form-label text-uppercase fw-bold me-3">Fra</label>
				<div class="d-flex flex-row gap-2">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.fra" id="add_cscinspectiontank_fra" placeholder="Enter Fra" >
					<input type="text" class="form-control w-50"  v-model="smtestingfieldFormObj.fra_blank" id="add_cscinspectiontank_fra_blank" >
				</div>
			</div>
		</div>
		<div class="row mb-4 gy-3 gy-md-0">
			<div class="col-md-5">
				<div class='row g-3'>
					<div class="col-12">
						<h4 class="m-0 fw-bold">Tank Information</h4>
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_mfg_year" class="form-label text-uppercase fw-bold me-3">Year of Manufacture</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_mfg_year" id="add_cscinspectiontank_tank_mfg_year" placeholder="Enter Mfg Year" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_max_g_wt" class="form-label text-uppercase fw-bold me-3">Max Gross Weight (Kg)</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_max_g_wt" id="add_cscinspectiontank_tank_max_g_wt" placeholder="Enter Max G Wt" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_tare_wt" class="form-label text-uppercase fw-bold me-3">Tare Weight (Kg)</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_tare_wt" id="add_cscinspectiontank_tank_tare_wt" placeholder="Enter Tank Tare Wt" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_capacity" class="form-label text-uppercase fw-bold me-3">Capacity (L)</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_capacity" id="add_cscinspectiontank_tank_capacity" placeholder="Enter Tank Capacity" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_desgin_temp" class="form-label text-uppercase fw-bold me-3">Design Temp (C)</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_desgin_temp" id="add_cscinspectiontank_tank_desgin_temp" placeholder="Enter Tank Desgin Temp" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_mawp_bar" class="form-label text-uppercase fw-bold me-3">M.A.W.P. (Bar)</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_mawp_bar" id="add_cscinspectiontank_tank_mawp_bar" placeholder="Enter Tank Mawp Bar" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_test_press_bar" class="form-label text-uppercase fw-bold me-3">Test Press(Bar)</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_test_press_bar" id="add_cscinspectiontank_tank_test_press_bar" placeholder="Enter Tank Test Press(Bar)" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_top_discharge" class="form-label text-uppercase fw-bold me-3">Top Discharge</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_top_discharge" id="add_cscinspectiontank_tank_top_discharge" placeholder="Enter Tank Top Discharge" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_bottom_discharge" class="form-label text-uppercase fw-bold me-3">Bottom Discharge</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_bottom_discharge" id="add_cscinspectiontank_tank_bottom_discharge" placeholder="Enter Tank Bottom Discharge" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_no_of_closure" class="form-label text-uppercase fw-bold me-3">No. of closures in series</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_no_of_closure" id="add_cscinspectiontank_tank_no_of_closure" placeholder="Enter Tank No Of Closure" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_shell_material" class="form-label text-uppercase fw-bold me-3">Shell Material</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_shell_material" id="add_cscinspectiontank_tank_shell_material" placeholder="Enter Tank Shell Material" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_shell_thickness" class="form-label text-uppercase fw-bold me-3">Shell Thickness(mm)</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_shell_thickness" id="add_cscinspectiontank_tank_shell_thickness" placeholder="Enter Tank Shell Thickness" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_heads_material" class="form-label text-uppercase fw-bold me-3">Heads Material</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_heads_material" id="add_cscinspectiontank_tank_heads_material" placeholder="Enter Tank Heads Material" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_head_thickness" class="form-label text-uppercase fw-bold me-3">Head Thickness (mm)</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_head_thickness" id="add_cscinspectiontank_tank_head_thickness" placeholder="Enter Tank Head Thickness" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_tank_iso_type" class="form-label text-uppercase fw-bold me-3">Iso Type</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.tank_iso_type" id="add_cscinspectiontank_tank_iso_type" placeholder="Enter Tank Iso Type" >
							
						</div>
						
					</div>
				</div>
			</div>
			<div class="col-md-7">
				<div class="row mb-2 mb-md-4">
					<div class="col-12">
						<h4 class="m-0 fw-bold">Inspection Dates (mm/yy)</h4>
					</div>
				</div>
				<div class='row mb-4 gy-3 gy-md-0'>
					<div class="col-md-6">
						<label for="add_cscinspectiontank_insp_init_hydro_date" class="form-label text-uppercase fw-bold me-3">Initial Hydro Test</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_init_hydro_date" id="add_cscinspectiontank_insp_init_hydro_date" placeholder="Enter Insp Init Hydro Date" >
							
						</div>
						
					</div>
					<div class="col-md-6">
						<label for="add_cscinspectiontank_insp_hydro_witness" class="form-label text-uppercase fw-bold me-3">Witness</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_hydro_witness" id="add_cscinspectiontank_insp_hydro_witness" placeholder="Enter Insp Hydro Witness" >
							
						</div>
						
					</div>
				</div>
				<div class='row mb-4 gy-3 gy-md-0'>
					<div class="col-md-6">
						<label for="add_cscinspectiontank_insp_last_hydro_date" class="form-label text-uppercase fw-bold me-3">Last Hydro Test</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_last_hydro_date" id="add_cscinspectiontank_insp_last_hydro_date" placeholder="Enter Insp Last Hydro Date" >
							
						</div>
						
					</div>
					<div class="col-md-6">
						<label for="add_cscinspectiontank_insp_last_hydro_witness" class="form-label text-uppercase fw-bold me-3">Witness</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_last_hydro_witness" id="add_cscinspectiontank_insp_last_hydro_witness" placeholder="Enter Insp Last Hydro Witness" >
							
						</div>
						
					</div>
				</div>
				<div class='row mb-4'>
					<div class="col-12 mb-4">
						<label for="add_cscinspectiontank_insp_date" class="form-label text-uppercase fw-bold me-3">This inspection date:</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_date" id="add_cscinspectiontank_insp_date" placeholder="Enter Insp Date" >
							
						</div>
						
					</div>
					<div class="col-12">
						<label for="add_cscinspectiontank_next_insp_date" class="form-label text-uppercase fw-bold me-3">Next CSC Due</label>
						<div class="input-group">
							
							<input type="text" class="form-control"  v-model="smtestingfieldFormObj.next_insp_date" id="add_cscinspectiontank_next_insp_date" placeholder="Enter Next Insp Date" >
							
						</div>
						
					</div>
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3 col-12">
				<h4 class="fw-bold text-center">Inspections Performed</h4>
			</div>
			<div class="col-md-3 col-4">
				<h4 class="fw-bold text-center">N/A</h4>
			</div>
			<div class="col-md-3 col-4">
				<h4 class="fw-bold text-center">In Order</h4>
			</div>
			<div class="col-md-3 col-4">
				<h4 class="fw-bold text-center">See Comments</h4>
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col-md-3 col-12 ">
				<label class="form-label text-uppercase fw-bold">Internal Inspection</label>
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_inter_perfom_na" class="form-label text-uppercase fw-bold me-3">Insp Inter Perfom Na</label> -->
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_inter_perfom_na" id="add_cscinspectiontank_insp_inter_perfom_na" placeholder="Enter Insp Inter Perfom Na" >
				</div>
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_inter_perfom_in" class="form-label text-uppercase fw-bold me-3">Insp Inter Perfom In</label> -->
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_inter_perfom_in" id="add_cscinspectiontank_insp_inter_perfom_in" placeholder="Enter Insp Inter Perfom In" >
				</div>
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_inter_perfom_remark" class="form-label text-uppercase fw-bold me-3">Insp Inter Perfom Remark</label> -->
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_inter_perfom_remark" id="add_cscinspectiontank_insp_inter_perfom_remark" placeholder="Enter Insp Inter Perfom Remark" >
				</div>
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col-md-3 col-12 ">
				<label class="form-label text-uppercase fw-bold">External Inspection</label>
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_ext_perfom_na" class="form-label text-uppercase fw-bold me-3">Insp Ext Perfom Na</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_ext_perfom_na" id="add_cscinspectiontank_insp_ext_perfom_na" placeholder="Enter Insp Ext Perfom Na" >
					
				</div>
				
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_ext_perfom_in" class="form-label text-uppercase fw-bold me-3">Insp Ext Perfom In</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_ext_perfom_in" id="add_cscinspectiontank_insp_ext_perfom_in" placeholder="Enter Insp Ext Perfom In" >
					
				</div>
				
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_ext_perfom_remark" class="form-label text-uppercase fw-bold me-3">Insp Ext Perfom Remark</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_ext_perfom_remark" id="add_cscinspectiontank_insp_ext_perfom_remark" placeholder="Enter Insp Ext Perfom Remark" >
					
				</div>
				
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col-md-3 col-12 d-flex flex-row gap-2 align-items-center">
				<label class="form-label text-uppercase fw-bold">Date</label>
				<input type="text" class="form-control w-50"  v-model="smtestingfieldFormObj.date" id="add_date">
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_perfom_date_na" class="form-label text-uppercase fw-bold me-3">Insp Perfom Date Na</label> -->
				<div class="input-group">
					
					<!-- <input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_date_na" id="add_cscinspectiontank_insp_perfom_date_na" placeholder="Enter Insp Perfom Date" > -->
					
				</div>
				
			</div>
			<!-- <div class="col-md-3 col-4">
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_date_in" id="add_cscinspectiontank_insp_perfom_date_in" placeholder="Enter Insp Perfom Date In" >
				</div>
			</div>
			<div class="col-md-3 col-4">
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_date_remark" id="add_cscinspectiontank_insp_perfom_date_remark" placeholder="Enter Insp Perfom Date Remark" >
				</div>
			</div> -->
		</div>
		<div class='row mb-4'>
			<div class="col-md-3 col-12 d-flex flex-row gap-2 align-items-center">
				<label class="form-label text-uppercase fw-bold mb-0">Pressure (Bar)</label>
				<input type="text" class="form-control w-50"  v-model="smtestingfieldFormObj.pressure_bar" id="add_pressure_bar">
			</div>
			<!-- <div class="col-md-3 col-4">
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_pressure_bar_na" id="add_cscinspectiontank_insp_perfom_pressure_bar_na" placeholder="Enter Insp Perfom Pressure Bar Na" >
				</div>
			</div>
			<div class="col-md-3 col-4">
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_pressure_bar_in" id="add_cscinspectiontank_insp_perfom_pressure_bar_in" placeholder="Enter Insp Perfom Pressure Bar In" >
				</div>
			</div>
			<div class="col-md-3 col-4">
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_pressure_bar_remark" id="add_cscinspectiontank_insp_perfom_pressure_bar_remark" placeholder="Enter Insp Perfom Pressure Bar Remark" >
				</div>
			</div> -->
		</div>
		<div class='row mb-4'>
			<div class="col-md-3 col-12 d-flex flex-row gap-2 align-items-center">
				<label class="form-label text-uppercase fw-bold">Post Hydro Leakproof Test</label>
				<input type="text" class="form-control w-50"  v-model="smtestingfieldFormObj.post_hydro" id="add_post_hydro">

			</div>
			<div class="col-md-3 col-4">
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_post_hydro_test_na" id="add_cscinspectiontank_insp_post_hydro_test_na" placeholder="Enter post hydro Na" >
					
				</div>
				
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_ext_perfom_in" class="form-label text-uppercase fw-bold me-3">Insp Ext Perfom In</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_post_hydro_test_in" id="add_cscinspectiontank_insp_post_hydro_test_in" placeholder="Enter post hydro In" >
					
				</div>
				
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_ext_perfom_remark" class="form-label text-uppercase fw-bold me-3">Insp Ext Perfom Remark</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_post_hydro_test_remark" id="add_cscinspectiontank_insp_post_hydro_test_remark" placeholder="Enter post hydro Remark" >
					
				</div>
				
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col-md-3 col-12 ">
				<label class="form-label text-uppercase fw-bold">Fitting Inspection</label>
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_perfom_fittin_na" class="form-label text-uppercase fw-bold me-3">Insp Perfom Fittin Na</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_fittin_na" id="add_cscinspectiontank_insp_perfom_fittin_na" placeholder="Enter Insp Perfom Fittin Na" >
					
				</div>
				
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_perfom_fittin_in" class="form-label text-uppercase fw-bold me-3">Insp Perfom Fittin In</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_fittin_in" id="add_cscinspectiontank_insp_perfom_fittin_in" placeholder="Enter Insp Perfom Fittin In" >
					
				</div>
				
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_perfom_fittin_remark" class="form-label text-uppercase fw-bold me-3">Insp Perfom Fittin Remark</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_fittin_remark" id="add_cscinspectiontank_insp_perfom_fittin_remark" placeholder="Enter Insp Perfom Fittin Remark" >
					
				</div>
				
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col-md-3 col-12 ">
				<label class="form-label text-uppercase fw-bold">Frame Inspection</label>
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_perfom_frame_na" class="form-label text-uppercase fw-bold me-3">Insp Perfom Frame Na</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_frame_na" id="add_cscinspectiontank_insp_perfom_frame_na" placeholder="Enter Insp Perfom Frame Na" >
					
				</div>
				
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_perfom_frame_in" class="form-label text-uppercase fw-bold me-3">Insp Perfom Frame In</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_frame_in" id="add_cscinspectiontank_insp_perfom_frame_in" placeholder="Enter Insp Perfom Frame In" >
					
				</div>
				
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_perfom_frame_remark" class="form-label text-uppercase fw-bold me-3">Insp Perfom Frame Remark</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_frame_remark" id="add_cscinspectiontank_insp_perfom_frame_remark" placeholder="Enter Insp Perfom Frame Remark" >
					
				</div>
				
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col-md-3 col-12 ">
				<label class="form-label text-uppercase fw-bold">Decals Inspection</label>
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_perfom_decals_na" class="form-label text-uppercase fw-bold me-3">Insp Perfom Decals Na</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_decals_na" id="add_cscinspectiontank_insp_perfom_decals_na" placeholder="Enter Insp Perfom Decals Na" >
					
				</div>
				
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_perfom_decals_in" class="form-label text-uppercase fw-bold me-3">Insp Perfom Decals In</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_decals_in" id="add_cscinspectiontank_insp_perfom_decals_in" placeholder="Enter Insp Perfom Decals In" >
					
				</div>
				
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_perfom_decals_remark" class="form-label text-uppercase fw-bold me-3">Insp Perfom Decals Remark</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_decals_remark" id="add_cscinspectiontank_insp_perfom_decals_remark" placeholder="Enter Insp Perfom Decals Remark" >
					
				</div>
				
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col-md-3 col-12 d-flex flex-row gap-2 align-items-center">
				<label class="form-label text-uppercase fw-bold">Steam Coils Test Pressure (Bar):</label>
				<input type="text" class="form-control w-50"  v-model="smtestingfieldFormObj.steam_coils" id="add_steam_coils">
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_perfom_steam_na" class="form-label text-uppercase fw-bold me-3">Steam Coils Test Pressure (Bar):</label> -->
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_steam_na" id="add_cscinspectiontank_insp_perfom_steam_na" placeholder="Enter Insp Perfom Steam Na" >
				</div>
				
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_perfom_steam_in" class="form-label text-uppercase fw-bold me-3">Insp Perfom Steam In</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_steam_in" id="add_cscinspectiontank_insp_perfom_steam_in" placeholder="Enter Insp Perfom Steam In" >
					
				</div>
				
			</div>
			<div class="col-md-3 col-4">
				<!-- <label for="add_cscinspectiontank_insp_perfom_steam_remark" class="form-label text-uppercase fw-bold me-3">Insp Perfom Steam Remark</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.insp_perfom_steam_remark" id="add_cscinspectiontank_insp_perfom_steam_remark" placeholder="Enter Insp Perfom Steam Remark" >
					
				</div>
				
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-4 col-12">
				<h4 class="fw-bold text-center">Pressure Relief Valves</h4>
			</div>
			<div class="col-md-4 col-6">
				<h4 class="fw-bold text-center">1st</h4>
			</div>
			<div class="col-md-4 col-6">
				<h4 class="fw-bold text-center">2nd</h4>
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col-md-4 col-12 ">
				<label class="form-label text-uppercase fw-bold">Manufacturer/Type:</label>
			</div>
			<div class="col-md-4 col-6">
				<!-- <label for="add_cscinspectiontank_p_mfgr_type_1" class="form-label text-uppercase fw-bold me-3">Manufacturer/Type</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.p_mfgr_type_1" id="add_cscinspectiontank_p_mfgr_type_1" placeholder="Enter P Mfgr Type 1" >
					
				</div>
			</div>
			<div class="col-md-4 col-6">
				<!-- <label for="add_cscinspectiontank_p_mfgr_type_2" class="form-label text-uppercase fw-bold me-3">P Mfgr Type 2</label> -->
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.p_mfgr_type_2" id="add_cscinspectiontank_p_mfgr_type_2" placeholder="Enter P Mfgr Type 2" >
				</div>
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col-md-4 col-12 ">
				<label class="form-label text-uppercase fw-bold">Serial Number</label>
			</div>
			<div class="col-md-4 col-6">
				<!-- <label for="add_cscinspectiontank_p_sr_no_1" class="form-label text-uppercase fw-bold me-3">Serial Number</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.p_sr_no_1" id="add_cscinspectiontank_p_sr_no_1" placeholder="Enter P Sr No 1" >
					
				</div>
				
			</div>
			<div class="col-md-4 col-6">
				<!-- <label for="add_cscinspectiontank_p_sr_no_2" class="form-label text-uppercase fw-bold me-3">P Sr No 2</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.p_sr_no_2" id="add_cscinspectiontank_p_sr_no_2" placeholder="Enter P Sr No 2" >
					
				</div>
				
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col-md-4 col-12 ">
				<label class="form-label text-uppercase fw-bold">Full Flow Rate (CMHR)</label>
			</div>
			<div class="col-md-4 col-6">
				<!-- <label for="add_cscinspectiontank_p_full_flow_rate_1" class="form-label text-uppercase fw-bold me-3">Full Flow Rate (CMHR)</label> -->
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.p_full_flow_rate_1" id="add_cscinspectiontank_p_full_flow_rate_1" placeholder="Enter P Full Flow Rate 1" >
				</div>
			</div>
			<div class="col-md-4 col-6">
				<!-- <label for="add_cscinspectiontank_p_full_flow_rate_2" class="form-label text-uppercase fw-bold me-3">P Full Flow Rate 2</label> -->
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.p_full_flow_rate_2" id="add_cscinspectiontank_p_full_flow_rate_2" placeholder="Enter P Full Flow Rate 2" >
				</div>
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col-md-4 col-12 ">
				<label class="form-label text-uppercase fw-bold">Operating Pressure (Bar)</label>
			</div>
			<div class="col-md-4 col-6">
				<!-- <label for="add_cscinspectiontank_p_operating_press_1" class="form-label text-uppercase fw-bold me-3">Operating Pressure (Bar)</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.p_operating_press_1" id="add_cscinspectiontank_p_operating_press_1" placeholder="Enter P Operating Press 1" >
					
				</div>
				
			</div>
			<div class="col-md-4 col-6">
				<!-- <label for="add_cscinspectiontank_p_operating_press_2" class="form-label text-uppercase fw-bold me-3">P Operating Press 2</label> -->
				<div class="input-group">
					
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.p_operating_press_2" id="add_cscinspectiontank_p_operating_press_2" placeholder="Enter P Operating Press 2" >
					
				</div>
				
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col-md-4 col-12 ">
				<label class="form-label text-uppercase fw-bold">Vacuum Setting (Hg)</label>
			</div>
			<div class="col-md-4 col-6">
				<!-- <label for="add_cscinspectiontank_p_vacuum_setting_1" class="form-label text-uppercase fw-bold me-3">Vacuum Setting (Hg)</label> -->
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.p_vacuum_setting_1" id="add_cscinspectiontank_p_vacuum_setting_1" placeholder="Enter P Vacuum Setting 1" >
				</div>
			</div>
			<div class="col-md-4 col-6">
				<!-- <label for="add_cscinspectiontank_p_vacuum_setting_2" class="form-label text-uppercase fw-bold me-3">P Vacuum Setting 2</label> -->
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.p_vacuum_setting_2" id="add_cscinspectiontank_p_vacuum_setting_2" placeholder="Enter P Vacuum Setting 2" >
				</div>
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col-md-4 col-12 ">
				<label class="form-label text-uppercase fw-bold">Bursting Disc (Bar)</label>
			</div>
			<div class="col-md-4 col-6">
				<!-- <label for="add_cscinspectiontank_p_bursting_disc_1" class="form-label text-uppercase fw-bold me-3">Bursting Disc (Bar)</label> -->
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.p_bursting_disc_1" id="add_cscinspectiontank_p_bursting_disc_1" placeholder="Enter P Bursting Disc 1" >
				</div>
			</div>
			<div class="col-md-4 col-6">
				<!-- <label for="add_cscinspectiontank_p_bursting_disc_2" class="form-label text-uppercase fw-bold me-3">P Bursting Disc 2</label> -->
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.p_bursting_disc_2" id="add_cscinspectiontank_p_bursting_disc_2" placeholder="Enter P Bursting Disc 2" >
				</div>
			</div>
		</div>
		<div class='row mb-4'>
			<div class="col">
				<label for="add_cscinspectiontank_comments" class="form-label text-uppercase fw-bold me-3">Comments</label>
				<div>
					<textarea class="form-control" v-model="smtestingfieldFormObj.comments" rows="3" id="add_cscinspectiontank_comments" placeholder="Enter Comments"></textarea>
				</div>
				
			</div>
		</div>
		<div class='row mb-4 gy-3 gy-md-0'>
			<div class="col-md-6">
				<label for="add_cscinspectiontank_platemark" class="form-label text-uppercase fw-bold me-3">Plate Marking/Stamping:</label>
				<div class="input-group">
					<input type="text" class="form-control"  v-model="smtestingfieldFormObj.platemark" id="add_cscinspectiontank_platemark" placeholder="Enter Platemark" >
				</div>
			</div>
			<div class="col-md-6">
				<label for="add_cscinspectiontank_surveyor_id" class="form-label text-uppercase fw-bold me-3">Surveyor Id</label>
				<div>
					<multiselect v-model="smtestingfieldFormObj.surveyor_id" :options="allSurveyorIdList" :custom-label="displayLabelSetting"  placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
				</div>
			</div>
		</div>

		<div class="row justify-content-center" v-if="!isModal">
			<div class="col-5">
				<a class="btn btn-success w-100" @click="saveSmTestingField()">Save</a>
			</div>
		</div>
	</div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { required, minValue, alphaNum, numeric, email, requiredIf, minLength,maxLength, decimal, url } from '@vuelidate/validators';
function initialState(){
	return {
		id:0,
		company_id:'',
		inspection_date:'',
		scope:'',
		inspection_location_id:'',
		operator_lessor:'',
		tank_no:'',
		mfg:'',
		mfg_sr_no:'',
		csc:'',
		csc_blank: '',
		uk_dot:'',
		uk_dot_blank:'',
		imdg:'',
		imdg_blank:'',
		us_dot:'',
		us_dot_blank:'',
		rid:'',
		rid_blank:'',
		aar:'',
		aar_blank:'',
		bam:'',
		bam_blank:'',
		tc_impact:'',
		tc_impact_blank:'',
		tir:'',
		tir_blank: '',
		uic:'',
		uic_blank:'',
		fra:'',
		fra_blank:'',
		tank_mfg_year:'',
		tank_max_g_wt:'',
		tank_tare_wt:'',
		tank_capacity:'',
		tank_desgin_temp:'',
		tank_mawp_bar:'',
		tank_test_press_bar:'',
		tank_top_discharge:'',
		tank_bottom_discharge:'',
		tank_no_of_closure:'',
		tank_shell_material:'',
		tank_shell_thickness:'',
		tank_heads_material:'',
		tank_head_thickness:'',
		tank_iso_type:'',
		insp_init_hydro_date:'',
		insp_hydro_witness:'',
		insp_last_hydro_date:'',
		insp_last_hydro_witness:'',
		insp_date:'',
		next_insp_date:'',
		insp_inter_perfom_na:'',
		insp_inter_perfom_in:'',
		insp_inter_perfom_remark:'',
		insp_ext_perfom_na:'',
		insp_ext_perfom_in:'',
		insp_ext_perfom_remark:'',
		post_hydro:'',
		insp_post_hydro_test_na: '',
		insp_post_hydro_test_in: '',
		insp_post_hydro_test_remark: '',
		date:'',
		insp_perfom_date_na:'',
		insp_perfom_date_in:'',
		insp_perfom_date_remark:'',
		pressure_bar: '',
		insp_perfom_pressure_bar_na:'',
		insp_perfom_pressure_bar_in:'',
		insp_perfom_pressure_bar_remark:'',
		insp_perfom_fittin_na:'',
		insp_perfom_fittin_in:'',
		insp_perfom_fittin_remark:'',
		insp_perfom_frame_na:'',
		insp_perfom_frame_in:'',
		insp_perfom_frame_remark:'',
		insp_perfom_decals_na:'',
		insp_perfom_decals_in:'',
		insp_perfom_decals_remark:'',
		steam_coils: '',		
		insp_perfom_steam_na:'',
		insp_perfom_steam_in:'',
		insp_perfom_steam_remark:'',
		p_mfgr_type_1:'',
		p_mfgr_type_2:'',
		p_sr_no_1:'',
		p_sr_no_2:'',
		p_full_flow_rate_1:'',
		p_full_flow_rate_2:'',
		p_operating_press_1:'',
		p_operating_press_2:'',
		p_vacuum_setting_1:'',
		p_vacuum_setting_2:'',
		p_bursting_disc_1:'',
		p_bursting_disc_2:'',
		platemark:'',
		comments:'',
		surveyor_id:'',
		deleted_at:'',
		created_at:'',
		updated_at:'',

		reload: false,
		closed: false,
		action: ''
	};
}
function initialStateValidations() {
	return {
		
	}
}
export default {
	name: "SmTestingFieldmaster",
	props: ['current_user_id', 'all_permissions','id', 'isModal', 'smtestingfieldForAdd', 'reload', 'closed'],
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data(){
		return{
			addEditModal: null,
			currentUser: siteUserObject,
			imageId: 0,
			allCompanyIdList: [],
			allInspectionLocationIdList: [],
			allSurveyorIdList: [],
			smtestingfieldFormObj: initialState(),
		}
	},
	validations() {
		return {
			smtestingfieldFormObj: initialStateValidations()
		};
	},
	
	methods: {
		canceladdedit(event){
			window.location = this.docRoot + '/smtestingfield';
		},
		formatDate(date) {
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
		async saveSmTestingField(event){
			var that = this;
			const result = await that.v$.$validate();
			if (!result) {
				that.showToast("Form validation failed. Please check.", "error", "bottom", 2000);
				console.log(that.v$.$errors);
				return;
			}
			if( !that.smtestingfieldFormObj.action || that.smtestingfieldFormObj.action == "" )
				that.smtestingfieldFormObj.action = "details";
			that.smtestingfieldFormObj.created_by = that.current_user_id;
			
			if (  typeof that.smtestingfieldFormObj.company_id === 'object' && that.smtestingfieldFormObj.company_id.id) {
				that.smtestingfieldFormObj.company_id = that.smtestingfieldFormObj.company_id.id;
			}
			if (  typeof that.smtestingfieldFormObj.inspection_location_id === 'object' && that.smtestingfieldFormObj.inspection_location_id.id) {
				that.smtestingfieldFormObj.inspection_location_id = that.smtestingfieldFormObj.inspection_location_id.id;
			}
			if (  typeof that.smtestingfieldFormObj.surveyor_id === 'object' && that.smtestingfieldFormObj.surveyor_id.id) {
				that.smtestingfieldFormObj.surveyor_id = that.smtestingfieldFormObj.surveyor_id.id;
			}
			that.showLoading("Saving ...");
			axios.post(that.docRoot+'/smtestingfield/save', { smtestingfield: that.smtestingfieldFormObj }).then(async function (response) {
				that.closeSwal();
				var status = response.data.status;
				if( status == 1 ){
					// Set the ID so that duplicate records will not be created
					that.smtestingfieldFormObj.id = response.data.id;
					that.showToast('SM Testing Field saved successfully', 'success', 'bottom', 3000);
					setTimeout(() => {
						window.location = that.docRoot + "/smtestingfield/";
						that.showLoading("Loading ...");
					}, 1500);
				}
				else{
					that.showErrors("SM Testing Field could not be saved successfully.", response.data.messages, "bottom", 3000);
				}
			})
			.catch(function (error) {
				console.log(error);
				that.closeSwal();
				that.showToast("SM Testing Field could not be saved successfully.", "error", "bottom", 3000);
			});
		},
		
		reloadEverything() {
			if (this.id !== undefined && !isNaN(this.id)) {
				this.mode = "edit";
				
				// This is Edit mode - fetch inquiry data
				var that = this;
				var URL = this.docRoot + "/api/smtestingfield/get-record/" + this.id;
				this.showLoading("Loading ...");
				axios
					.post(URL, {})
					.then(function (response) {
						that.closeSwal();
						that.smtestingfieldFormObj = Object.assign({}, response.data);
					})
					.catch(function (error) {
						console.log(error);
					});
			}
		},
		displayLabelSetting ({id, text}) {
			return `${text}`;
		},
	},
	async mounted() {
		if (this.id > 0){
			this.reloadEverything();
		}
		let _allCompanyIdList = await this.loadAllCompany(this.docRoot+'/api/company/get', 'post', {});
		if(Array.isArray(_allCompanyIdList) && _allCompanyIdList.length > 0){
			this.allCompanyIdList = _allCompanyIdList.map(x => {return { id: x.id, text: x.name }});
		}
		let _allInspectionLocationIdList = await this.loadAllInspectionLocation(this.docRoot+'/api/inspectionlocation/get', 'post', {});
		if(Array.isArray(_allInspectionLocationIdList) && _allInspectionLocationIdList.length > 0){
			this.allInspectionLocationIdList = _allInspectionLocationIdList.map(x => {return { id: x.id, text: x.name }});
		}
		let _allSurveyorIdList = await this.loadAllSurveyor(this.docRoot+'/api/surveyor/get', 'post', {});
		if(Array.isArray(_allSurveyorIdList) && _allSurveyorIdList.length > 0){
			this.allSurveyorIdList = _allSurveyorIdList.map(x => {return { id: x.id, text: x.name }});
		}
		if (this.smtestingfieldFormObj.company_id) {
			if (Array.isArray(this.allCompanyIdList) && this.allCompanyIdList.length > 0) {
				let _allRelationList = this.allCompanyIdList;
				let relationId = parseInt(this.smtestingfieldFormObj.company_id);
				this.smtestingfieldFormObj.company_id = _allRelationList.find(item => item.id === relationId);
			}
		}
		if (this.smtestingfieldFormObj.inspection_location_id) {
			if (Array.isArray(this.allInspectionLocationIdList) && this.allInspectionLocationIdList.length > 0) {
				let _allRelationList = this.allInspectionLocationIdList;
				let relationId = parseInt(this.smtestingfieldFormObj.inspection_location_id);
				this.smtestingfieldFormObj.inspection_location_id = _allRelationList.find(item => item.id === relationId);
			}
		}
		if (this.smtestingfieldFormObj.surveyor_id) {
			if (Array.isArray(this.allSurveyorIdList) && this.allSurveyorIdList.length > 0) {
				let _allRelationList = this.allSurveyorIdList;
				let relationId = parseInt(this.smtestingfieldFormObj.surveyor_id);
				this.smtestingfieldFormObj.surveyor_id = _allRelationList.find(item => item.id === relationId);
			}
		}
	}
}
</script>
